import { useAppSelector } from '../../../core/utils';
import { selectPrimaryCalculatorPaymentOptions } from '../../../core/reducers/financialCalculators';
import useDealerProvincePricing from '../../../utils/hooks/useDealerProvincePricing';
export const SellingPriceFlagSource = {
    dealer: 'dealer',
    geo: 'geo',
};
const useIsSellingPriceFlag = (sellingPriceFlagSource) => {
    const { overriddenIsSellingProvince: geoIsSellingPriceProvince } = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const { isSellingPriceProvince: dealerIsSellingPriceProvince } = useDealerProvincePricing();
    return sellingPriceFlagSource === SellingPriceFlagSource.dealer
        ? dealerIsSellingPriceProvince
        : geoIsSellingPriceProvince;
};
export default useIsSellingPriceFlag;
